import React from 'react'

import clsx from 'clsx'

import FeatureCheck from 'components/FeatureCheck'
import Grid from 'components/Grid'
import Paper from 'components/Paper'

import classes from './SupportOptions.module.scss'

/** @type {import("./types").default} */
const SupportOptions = ({ listing }) => {
  const toSentenceCase = name => {
    if (!name) return ''

    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
  }

  return (
    <Paper className={clsx('SupportOptions', classes.root)}>
      <Grid container spacing={2}>
        {listing.support_options.length > 0 && (
          <Grid item md={6} lg={12} sm={6} xs={12}>
            <p className={classes.featureTitle}>Support options</p>
            <div className={classes.featureList}>
              {listing.support_options.map(option => (
                <FeatureCheck key={option} checked>
                  {toSentenceCase(option)}
                </FeatureCheck>
              ))}
            </div>
          </Grid>
        )}
        {listing.training_options.length > 0 && (
          <Grid item md={6} lg={12} sm={6} xs={12} className={classes.trainingOptions}>
            <p className={classes.featureTitle}>Training options</p>
            <div className={classes.featureList}>
              {listing.training_options.map(option => (
                <FeatureCheck key={option} checked>
                  {toSentenceCase(option)}
                </FeatureCheck>
              ))}
            </div>
          </Grid>
        )}
      </Grid>
    </Paper>
  )
}

export default SupportOptions
